import { getGameConfig } from '../../../config/gameConfig';
import { getMaxWarmth, getRandomPersonName, hashStringSeed, mulberry32 } from '../utils';
import type { Person, Settlement } from '../types';

export function createPerson(settlement: Settlement): Person {
    settlement.personIdCounter += 1;
    const nameSeed = hashStringSeed(`${settlement.id}:${settlement.personIdCounter}`);
    const name = getRandomPersonName(getGameConfig().ui.language, mulberry32(nameSeed));
    return {
        id: `person_${settlement.id}_${settlement.personIdCounter}`,
        name,
        hunger: 0,
        warmth: getMaxWarmth(),
        houseId: null,
        job: null,
    };
}
